import { isPendingAssistantText } from '@/constants/chat'
import { normalizeMessages } from '@/features/chat/messageNormalize'

/** @param {Record<string, unknown[]>} prev @param {string} tid */
export function priorMessagesWithoutPending(prev, tid) {
  const rawPrior = normalizeMessages(prev[tid] ?? [])
  return rawPrior.filter(
    (msg) => !(msg.role === 'assistant' && isPendingAssistantText(msg.text)),
  )
}
